import React from 'react'
import AuthRouter from 'routes/Components/AuthRouter'
import { Routes, Route } from 'react-router'

const Routers = ({ token, getStudentData, SignIn }) => {
  const isAuthenticated = Boolean(token)
  return (
    <Routes>
      <Route
        path="/*"
        element={
          <AuthRouter
            isAuthenticated={isAuthenticated}
            getStudentData={getStudentData}
            SignIn={SignIn}
          />
        }
      />
    </Routes>
  )
}

export default Routers
